import React from "react";
import "../App.css";
import "../custom.css";
import "../dashboard.css";
import "./Login.css";
import logo from "../images/logo_001.png";
import axios from "axios";
import config from "../config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.Login = this.Login.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
    this.state = {
      email: "",
      password: "",
      alertEmail: "",
      showPassword: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.checkSession();
  }

  handleChangeEmail(event) {
    this.setState({
      email: event.target.value,
    });
  }

  handleChangePassword(event) {
    this.setState({
      password: event.target.value,
    });
  }

  handleKeyDown(event) {
    if (event.key === "Enter") {
      this.Login();
    }
  }

  togglePassword() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  Login() {
    if (this.state.isLoading) return;

    this.setState({ isLoading: true, alertEmail: "" });

    axios
      .post(config.host + "/api/v1/auth/login", {
        email: this.state.email,
        password: this.state.password,
      })
      .then((res) => {
        if (res.status === 200) {
          localStorage.StudioUserToken = res.data.token;
          localStorage.StudioUserID = res.data.user.auth.id;
          this.props.history.push("/home");
        }
      })
      .catch((err) => {
        this.setState({
          alertEmail: "Invalid email or password.",
          isLoading: false,
        });

        setTimeout(() => {
          this.setState({
            alertEmail: "",
          });
        }, 4000);
      });
  }

  checkSession = () => {
    if (!localStorage.StudioUserID) {
      this.props.history.push("/");
    } else {
      this.props.history.push("/home");
    }
  };

  render() {
    const { email, password, alertEmail, showPassword, isLoading } = this.state;

    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
        />
        <div className="login-page">
          <div className="login-shell">
            <div className="login-card">
              <div className="login-brand">
                <img
                  src={logo}
                  alt="i-IPTV Studio Portal"
                  className="login-logo"
                />
              </div>

              <h1 className="login-card__title">Login to your account</h1>

              {alertEmail && (
                <div className="login-alert" role="alert">
                  <i className="fas fa-exclamation-circle" aria-hidden="true" />
                  <span>{alertEmail}</span>
                </div>
              )}

              <div className="login-field">
                <label htmlFor="email">Username</label>
                <div className="login-input-wrap">
                  <i className="fas fa-user field-icon" aria-hidden="true" />
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={this.handleChangeEmail}
                    onKeyDown={this.handleKeyDown}
                    autoComplete="username"
                  />
                </div>
              </div>

              <div className="login-field">
                <label htmlFor="password">Password</label>
                <div className="login-input-wrap">
                  <i className="fas fa-lock field-icon" aria-hidden="true" />
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={this.handleChangePassword}
                    onKeyDown={this.handleKeyDown}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="login-toggle-password"
                    onClick={this.togglePassword}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    <i
                      className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </div>

              <div className="login-options">
                <label className="login-remember" htmlFor="remember_me">
                  <input type="checkbox" id="remember_me" />
                  <span>Keep me logged in</span>
                </label>
              </div>

              <button
                type="button"
                className="login-submit"
                onClick={this.Login}
                disabled={isLoading || !email || !password}
              >
                {isLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin" aria-hidden="true" />{" "}
                    Signing in...
                  </>
                ) : (
                  "Log in"
                )}
              </button>
            </div>

            <p className="login-footer">i-IPTV Studio Portal</p>
          </div>
        </div>
      </>
    );
  }
}

export default Login;
